import { Loader } from "@googlemaps/js-api-loader"

export default {
  init() {
    function initMap( $el ) {

      const loader = new Loader({
        apiKey: "AIzaSyCc4TQxO5Wym4fS0xBs9RJegH_0oEcqZ1Y",
        version: "weekly",
      });


      // Find marker elements within map.
      const $markers = $el.find('.marker');

      // Create gerenic map.
      let map

      loader.load().then(() => {
        const mapArgs = {
            zoom        : $el.data('zoom') || 16,
            mapTypeId   : window.google.maps.MapTypeId.ROADMAP,
            styles: [{
              "stylers": [{
                "saturation": -100
              }]
            }]
        };

        map = new window.google.maps.Map($el[0], mapArgs);

        map.markers = [];
        $markers.each(function(){
            initMarker( $(this), map );
        });

        // Center map based on markers.
        centerMap( map );
      });

      // Add markers.


      // Return map instance.
      return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker( $marker, map ) {

        // Get position from marker.
        const lat = $marker.data('lat');
        const lng = $marker.data('lng');
        const latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };

        // Create marker instance.
        const icon = {
            url: '/wp-content/themes/redboxmediarefonte2022/public/images/icon_animated.gif', // url
            scaledSize: new google.maps.Size(60, 77),
            anchor: new google.maps.Point(25, 40),
        };
        const marker = new window.google.maps.Marker({
            position : latLng,
            map: map,
            icon: icon
        });

        // Append to reference for later use.
        map.markers.push( marker );

        // If marker contains HTML, add it to an infoWindow.
        if( $marker.html() ){

            // Create info window.
            const infowindow = new window.google.maps.InfoWindow({
                content: $marker.html()
            });

            // Show info window when marker is clicked.
            window.google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap( map ) {

        // Create map boundaries from all map markers.
        const bounds = new window.google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });

        // Case: Single marker.
        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );

        // Case: Multiple markers.
        } else{
            map.fitBounds( bounds );
        }
    }

    // Render maps on page load.
    $(document).ready(function(){
        $('.acf-map').each(function(){
            initMap($(this));
        });
    });

  }
};
